import React from "react";
import "../../styles/LoadingComponent.css";

const LoadingComponent = () => {
  return (
    <div
      className="loading-screen flex w-full flex-1 flex-col items-center justify-center"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="sr-only">Loading</span>
      <div className="loading-dot-wave" aria-hidden>
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};

export default LoadingComponent;
